import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularProgressComponent from "../ReportOverview/CircularProgressComponent/CircularProgressComponent";
import "./AverageSummary.css";
import Locale from "../../locales";
import { teacherOverallReport } from "../../redux/actions/auth";

const AverageSummary = () => {
  const dispatch = useDispatch();
  const overallPerformanceReport = useSelector(
    (state) => state.authReducer.overallPerformanceReport,
  );
  const teacherMessage = useSelector(
    (state) => state.authReducer.teacherMessage,
  );
  const teacherId = useSelector((state) => state.authReducer.currentUser);

  useEffect(() => {
    if (teacherId) {
      dispatch(teacherOverallReport(teacherId));
    }
  }, [teacherId]);

  return (
    <div className="summary-container">
      <div className="average-summary-guideline-container">
        <h1>{Locale.t("welcome_to_blobit")}</h1>
        <h3>{Locale.t("click_on_a_student_to_get_started")}</h3>
      </div>
      <div className="average-summary-guideline-container">
        <h2>{Locale.t("your_class_average_performance")}</h2>
      </div>
      <div className="average-summary-charts-container">
        <div>
          <CircularProgressComponent
            size={60}
            thickness={6}
            variant="determinate"
            value={overallPerformanceReport?.averagePunctuality || 0}
          />
          <p>{Locale.t("punctuality")}</p>
        </div>
        <div>
          <CircularProgressComponent
            size={90}
            thickness={7}
            variant="determinate"
            value={overallPerformanceReport?.averageConsistency || 0}
          />
          <p>{Locale.t("consistency")}</p>
        </div>
        <div>
          <CircularProgressComponent
            size={60}
            thickness={6}
            variant="determinate"
            value={overallPerformanceReport?.averageRating || 0}
          />
          <p>{Locale.t("general_performance")}</p>
        </div>
      </div>
      <div className="super-admin-message">
        <h5>{Locale.t("Message_from_Instructor")}</h5>
        <h3>{teacherMessage || "No Message Yet"}</h3>
      </div>
    </div>
  );
};

export default AverageSummary;
